import { TeButtonOutline } from '@topcon/tuicl-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DeclineServiceAgreementModal from './DeclineServiceAgreementModal';
import { AddressInfo } from '../../api/generated/pm';

interface DeclineAgreementButtonProps {
  type?: 'requestBusinessPartner' | 'serviceAgreement';
  id: string;
  disabled?: boolean;
  onReject: () => void;
  company: {
    name: string;
    companyAddress: AddressInfo;
  };
}

function DeclineAgreementButton({
  id,
  disabled,
  onReject,
  type = 'serviceAgreement',
  company,
}: DeclineAgreementButtonProps) {
  const { t } = useTranslation();
  const [openDeclineDialog, setOpenDeclineDialog] = useState<boolean>(false);

  const onDecline = async () => {
    setOpenDeclineDialog(true);
    onReject();
  };

  return (
    <>
      <TeButtonOutline
        variant="tertiary"
        size="s"
        text={t('serviceAgreement.decline')}
        teclick={() => setOpenDeclineDialog(true)}
        disabled={disabled}
      />
      {openDeclineDialog && (
        <DeclineServiceAgreementModal
          open={openDeclineDialog}
          onClose={() => setOpenDeclineDialog(false)}
          onDecline={onDecline}
          id={id}
          company={company}
          type={type}
        />
      )}
    </>
  );
}

export { DeclineAgreementButton };
